import type { CodebaseResponse, GithubRepoPickerItem } from '@/lib/api';

// `can_connect` is the default / unobstructed state — the `+ Add` button
// already communicates that the row is ready to add, so we suppress its
// badge to keep the picker focused on rows that need attention (already
// added, or pending App access).
const GITHUB_REPO_PICKER_STATUS_LABELS: Record<
  GithubRepoPickerItem['pickerStatus'],
  string | null
> = {
  can_connect: null,
  needs_github_app_access: 'Needs GitHub App access',
  already_added: 'Already added',
};

function normalizeSearchQuery(query: string): string {
  return query.trim().toLowerCase();
}

function matchesGithubSearch(haystacks: (string | null | undefined)[], query: string): boolean {
  const normalizedQuery = normalizeSearchQuery(query);
  if (!normalizedQuery) {
    return true;
  }

  return haystacks.some(value => value?.toLowerCase().includes(normalizedQuery) ?? false);
}

export function isCodebaseGitHubConnected(
  codebase: Pick<CodebaseResponse, 'github_connection_status'>
): boolean {
  return codebase.github_connection_status === 'github_connected';
}

export function getGithubRepoPickerStatusLabel(
  repo: Pick<GithubRepoPickerItem, 'pickerStatus'>
): string | null {
  return GITHUB_REPO_PICKER_STATUS_LABELS[repo.pickerStatus];
}

export function filterGithubRepos(
  repos: readonly GithubRepoPickerItem[],
  query: string
): readonly GithubRepoPickerItem[] {
  return repos.filter(repo =>
    matchesGithubSearch(
      [
        repo.fullName,
        repo.owner,
        repo.name,
        repo.defaultBranch,
        getGithubRepoPickerStatusLabel(repo),
      ],
      query
    )
  );
}
